import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "placeholder", "output", "errorOutput", "disclaimer", "quota"]
  static values = { url: String, autostart: Boolean }

  connect() {
    this.buffer = ""
    if (this.autostartValue) {
      this.generate()
    }
  }

  generate() {
    this.buttonTarget.hidden = true
    this.placeholderTarget.hidden = false

    if (this.hasQuotaTarget) {
      this.quotaTarget.hidden = true
    }

    const url = new URL(this.urlValue, window.location.origin)

    this.source = new EventSource(url.toString())

    this.source.onmessage = (event) => {
      this.placeholderTarget.hidden = true
      this.disclaimerTarget.hidden = false
      this.buffer += event.data.replace(/\\n/g, "\n")
      this.outputTarget.innerHTML = this.buffer
    }

    this.source.addEventListener("done", () => {
      this.source.close()
    })

    this.source.addEventListener("error", (event) => {
      // Native connection-error events carry no data; only handle server-sent errors here.
      if (!event.data) return
      // If we don't have an error output target, just close the connection and do nothing.
      if (!this.hasErrorOutputTarget) {
        this.source.close()
        return
      }

      this.placeholderTarget.hidden = true
      this.disclaimerTarget.hidden = true
      this.outputTarget.innerHTML = ""
      this.outputTarget.hidden = true
      this.errorOutputTarget.hidden = false
      this.errorOutputTarget.innerHTML = event.data.replace(/\\n/g, "\n")

      this.source.close()
    })

    this.source.onerror = () => {
      this.source.close()
    }
  }

  disconnect() {
    if (this.source) {
      this.source.close()
    }
  }
}
